<template>
  <div>
    <el-form ref="formRef" :model="pushForm" label-width="100px">
      <el-form-item label="推送标题：">
        <el-input type="text" v-model="pushForm.title" placeholder="输入推送标题" style="width:24em;"/>
      </el-form-item>
      <el-form-item label="推送内容：">
        <el-input :rows="4" type="textarea" v-model="pushForm.content" placeholder="输入推送内容" style="width:24em;"/>
      </el-form-item>
      <el-form-item label="推送时间：">
        <el-date-picker
            v-model="pushForm.pushTime"
            type="datetime"
            placeholder="选择推送时间"
            format="YYYY-MM-DD HH:mm:ss"
            value-format="YYYY-MM-DD HH:mm:ss"
        />
      </el-form-item>
      <el-form-item label="性别：">
        <el-select v-model="sex" placeholder="Select" style="width: 24em">
          <el-option v-for="item in sexArray" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="VIP状态：">
        <el-select v-model="vipState" placeholder="Select" style="width: 24em">
          <el-option v-for="item in vipStateArray" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="新用户：">
        <el-select v-model="newUserState" placeholder="Select" style="width: 24em">
          <el-option v-for="item in newUserStateArray" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <div class="dialog-footer" style="text-align: center">
      <el-button @click.native="cancel" >取消</el-button>
      <el-button type="primary" @click="summit" v-loading="loading">确定</el-button>
    </div>
  </div>

</template>

<script>
import { postFormData } from "@/api/api"
import { addOrUpdatePushList } from "@/api/url";

export default {
  name: "GreetingDialog",
  props: {
    value: Object
  },
  data() {
    return {
      pushForm: this.value.pushForm,
      idx: this.value.ids,
      loading: false,

      sexArray: [
        {label: '通用', value: 0},
        {label: '男', value: 1},
        {label: '女', value: 2},
      ],
      sex: this.value.pushForm.sex?this.value.pushForm.sex:0,

      vipStateArray: [
        {label: '通用', value: 0},
        {label: 'vip', value: 1},
        {label: '非vip', value: 2},
        {label: 'vip已失效', value: 3},
      ],
      vipState: this.value.pushForm.vipState?this.value.pushForm.vipState:0,

      newUserStateArray: [
        {label: '通用', value: 0},
        {label: '旧用户', value: 1},
        {label: '新用户', value: 2},
      ],
      newUserState: this.value.pushForm.newUserState?this.value.pushForm.newUserState:0,

    }
  },
  methods: {
    cancel() {
      this.$emit("close");
    },


    //更改或添加
    headImgUpdate() {
      this.$refs.headImg.click();
    },

    //选取图片
    headImgChanged(e) {
      if(e.target.files[0]) {
        this.files = e.target.files[0];
        var windowURL = window.URL || window.webkitURL;
        this.src = windowURL.createObjectURL(this.files);
      }
    },

    summit() {
      if(!this.pushForm.title) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '标题不能为空',
          type: 'warning'
        });
        return false
      }
      if(!this.pushForm.content) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '内容不能为空',
          type: 'warning'
        });
        return false
      }
      if(!this.pushForm.pushTime) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '请选择推送时间',
          type: 'warning'
        });
        return false
      }
      this.loading = true
      let param = {};
      param['id'] = this.idx > -1?this.pushForm.id:0;
      param['title'] = this.pushForm.title;
      param['content'] = this.pushForm.content;
      param['pushTime'] = this.pushForm.pushTime;
      param['sex'] = this.sex;
      param['vipState'] = this.vipState;
      param['newUserState'] = this.newUserState;
      postFormData(addOrUpdatePushList, param).then((data) => {
        let {msg, code} = data
        if (code == 200) {
          this.$message({
            showClose: true,
            duration: 2000,
            message: msg,
            type: 'success'
          });
          this.$emit('confirm')
        }else {
          this.$message({
            showClose: true,
            duration: 2000,
            message: msg,
            type: 'warning'
          });
        }
        this.loading = false
      }).catch(()=>{
        this.loading = false
      })
    }
  },
  mounted() {

  }
}
</script>

<style scoped>
.add {
  width: 80px;
  height: 80px;
  text-align: center;
  line-height: 80px;
  border: 1px dashed #ececec;
  font-size: 30px;
  cursor: pointer;
  float: left;
}
</style>
